<template>
    <div
        class="checkout-cart"
        id="checkout-cart"
    >
        <p class="dropdown-cart-info">オーダー内容</p>
        <div class="dropdown-menu-wrapper">
            <div
                class="overlay"
                v-if="loading"
            >
                <i class="fa fa-refresh fa-spin"></i>
            </div>
            <p v-if="!orderItems.length">カートに商品が入っていません</p>

            <div
                class="product"
                v-show="orderItems.length"
                v-for="orderItem in orderItems"
            >
                <order-product-item :order-item="orderItem" />
            </div>
        </div>

        <div
            class="cart-dropdowm-action"
            v-show="orderItems.length && isCartPrice"
        >
            <div class="dropdowm-cart-total"><span>合計: </span>¥{{ totalPrice }}</div>
            <template v-if="cartEditBtn">
                <a
                    href="/cart"
                    class="btn btn-accent"
                    >カート編集</a
                >
            </template>
        </div>

        <div
            class="cart-dropdowm-action"
            v-if="!isCartPrice"
        >
            <slot name="priceBox"></slot>
        </div>
    </div>
</template>
<script>
import linq from 'linq'
import OrderItem from '../models/OrderItem'
import OrderProductItem from './order/OrderProductItem.vue'

export default {
    name: 'cart',
    components: { OrderProductItem },

    data() {
        return {
            orderItems: [],
            totalPrice: 0,
            loading: true,
        }
    },

    created() {
        this.getCartItems()
    },

    props: {
        cartEditBtn: {
            type: Boolean,
            default: true,
        },
        isCartPrice: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        async getCartItems() {
            this.loading = true
            const { data } = await axios.get('/api/cart/get')
            this.orderItems = data.map((x) => new OrderItem(x))
            this.setImage(this.orderItems)
            this.setTotalPrice()
            this.loading = false
        },

        setImage(data) {
            linq.from(data).forEach((x) => {
                if (x.image) {
                    x.item.product.imgPath = x.image
                }
            })
        },

        setTotalPrice() {
            let price = 0
            linq.from(this.orderItems)
                .select((x) => x.item.priceJpy * x.count)
                .select((x) => (price += x))
                .toArray()
            this.totalPrice = Number(price).toLocaleString()
        },
    },
}
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Cart.vue